import { LOCK_TYPE } from '../types';

import type { VisualizationAxis, VisualizationMeasurement } from './types';

export const DISTANCE_MEASUREMENTS = {
    distance_between_elbows: {
        label: 'Distance between elbows',
        type: 'measurement',
        axes: ['distance_between_elbows_distance'],
    },
    arc_width: {
        label: 'Arc width',
        type: 'measurement',
        axes: ['arc_width_distance'],
    },
    club_head_distance_to_shaft_plane_at_setup: {
        label: 'Club head distance to shaft plane at setup',
        type: 'measurement',
        axes: ['club_head_distance_to_shaft_plane_at_setup_distance'],
    },
    club_shaft_distance_to_shaft_plane_at_setup: {
        label: 'Club shaft distance to shaft plane at setup',
        type: 'measurement',
        axes: ['club_shaft_distance_to_shaft_plane_at_setup_distance'],
    },
    shoulder_mid_vs_pelvis_gap: {
        label: 'Shoulder Mid vs Pelvis gap',
        type: 'measurement',
        axes: ['shoulder_mid_vs_pelvis_gap_distance'],
    },
} as const satisfies Record<string, VisualizationMeasurement>;

export const DISTANCE_MEASUREMENTS_PARENT_MAP = Object.fromEntries(
    Object.entries(DISTANCE_MEASUREMENTS).flatMap(([measurementId, measurement]) =>
        measurement.axes.map((axisId) => [axisId, measurementId] as [string, string]),
    ),
);

export const DISTANCE_AXES: Record<string, VisualizationAxis> = {
    distance_between_elbows_distance: {
        id: 'distance_between_elbows_distance',
        measurementName: 'distance_between_elbows',
        axisIndex: 0,
        label: 'Distance',
        unit: 'm',
        targetPoints: ['left_elbow', 'right_elbow'],
        camera: {
            type: LOCK_TYPE.STATIC,
            azimuthal: -Math.PI / 2,
            polar: Math.PI / 2,
        },
    },

    arc_width_distance: {
        id: 'arc_width_distance',
        measurementName: 'arc_width',
        axisIndex: 0,
        label: 'Distance',
        unit: 'm',
        targetPoints: ['left_wrist'],
        camera: {
            type: LOCK_TYPE.STATIC,
            azimuthal: -Math.PI / 2,
            polar: Math.PI / 2,
        },
    },

    club_head_distance_to_shaft_plane_at_setup_distance: {
        id: 'club_head_distance_to_shaft_plane_at_setup_distance',
        measurementName: 'club_head_distance_to_shaft_plane_at_setup',
        axisIndex: 0,
        label: 'Distance',
        unit: 'm',
        targetPoints: ['left_wrist'],
        camera: {
            type: LOCK_TYPE.STATIC,
            azimuthal: -Math.PI / 2,
            polar: Math.PI / 2,
        },
    },

    club_shaft_distance_to_shaft_plane_at_setup_distance: {
        id: 'club_shaft_distance_to_shaft_plane_at_setup_distance',
        measurementName: 'club_shaft_distance_to_shaft_plane_at_setup',
        axisIndex: 0,
        label: 'Distance',
        unit: 'm',
        targetPoints: ['left_wrist'],
        camera: {
            type: LOCK_TYPE.STATIC,
            azimuthal: -Math.PI / 2,
            polar: Math.PI / 2,
        },
    },

    shoulder_mid_vs_pelvis_gap_distance: {
        id: 'shoulder_mid_vs_pelvis_gap_distance',
        measurementName: 'shoulder_mid_vs_pelvis_gap',
        axisIndex: 0,
        label: 'Distance',
        unit: 'm',
        targetPoints: ['upper_torso', 'pelvis'],
        camera: {
            type: LOCK_TYPE.STATIC,
            azimuthal: -Math.PI / 2,
            polar: Math.PI / 2,
        },
    },
};
